import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const ErrorBoundaryQaPanelStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "error-boundary-qa-panel",
})`
  padding-block: 20px;
  padding-inline-start: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 400px;

  h2 {
    color: ${greyMui._600};
    font-size: 17px;
    padding-bottom: 10px;
    margin: 0;
  }

  button {
    width: fit-content;
    min-width: 200px;
  }
`;
